import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";

import FormComponent from "../../Components/FormComponent";
import Validator from "../../Components/FormComponent/Validator";

import "./HSGModalComponent.css";

const HSGModalBackdropStyle = {
    top: 0,
    backgroundColor: "#000",
    opacity: 0.5,
};

export default class HSGModalComponent extends Component {
    getForm = ({ formDefs, onClose, onSubmit, onBlur }) => (
        <FormComponent onClose={onClose} onSubmit={onSubmit} formDefs={formDefs} onFieldBlur={onBlur} />
    );

    getButtonActions = (e, onClick) => {
        e.preventDefault();
        onClick && onClick(e);
        this.props.onHide && this.props.onHide();
    };

    getButtons = (buttons) => (
        <div className="text-right">
            {buttons.map((button, i) => (
                <button
                    key={i}
                    className={button.className || "hsg-btn"}
                    onClick={(e) => this.getButtonActions(e, button.onClick)}
                >
                    {button.text}
                </button>
            ))}
        </div>
    );

    getBody = (bodyText, buttons) =>
        bodyText ? (
            <div>
                {bodyText}
                {buttons && buttons.length && this.getButtons(buttons)}
            </div>
        ) : null;

    render = () => {
        const { props } = this;
        const onBlur = props.onBlur ? props.onBlur : () => {};
        return (
            <Modal
                className="hsg-modal-main"
                show={props.show}
                onHide={() => props.onHide()}
                onClose={() => props.onClose()}
                bsSize={props.bsSize}
                backdropStyle={HSGModalBackdropStyle}
            >
                {props.header ? (
                    <Modal.Header className="hsg-modal-header">
                        <div className="hsg-modal-header-text center col-md-12 col-sm-12 col-xs-12">{props.header}</div>
                        {props.onClose ? <i
                            className="fa fa-times hsg-modal-close-button"
                            aria-hidden="true"
                            onClick={props.onClose}
                        ></i> : null}
                    </Modal.Header>
                ) : props.showClose && props.onClose ?
                <Modal.Header className={"hsg-modal-header-no-space"}>
                    <i
                        className="fa fa-times hsg-modal-close-button"
                        aria-hidden="true"
                        onClick={props.onClose}
                    ></i>
                </Modal.Header> : null}
                <Modal.Body className="hsg-modal-body">
                    {props.isForm ? this.getForm({ ...props, onBlur }) : this.getBody(props.body, props.buttons)}
                </Modal.Body>
            </Modal>
        );
    };
}

HSGModalComponent.defaultProps = {
    isForm: false,
    bsSize: null,
};

HSGModalComponent.propTypes = {
    formDefs: PropTypes.object,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func,
    header: PropTypes.string,
    bsSize: PropTypes.string,
    isForm: PropTypes.bool.isRequired,
    body: PropTypes.object,
    buttons: PropTypes.arrayOf(
        PropTypes.shape({
            className: PropTypes.string,
            onClick: PropTypes.func.isRequired,
            text: PropTypes.string.isRequired,
        })
    ),
};
